<script setup lang="ts">
import SvgIcon from "~/components/Common/SvgIcon.vue";
import { useSessionIndividual } from "~/composables/sessions/useSessionIndividual";
import { useAuthStore } from "~/store/auth/auth.store";

const sessionIndividual = useSessionIndividual();
const authStore = useAuthStore();

const data = sessionIndividual.getUserInfos();
</script>

<template>
  <div class="session_user_info__container">
    <div class="flex items-center justify-between">
      <h3 class="heading_3_demi text-primary-color p-[8px]">Infos participant</h3>
      <div
        v-if="authStore.isCompanyAdmin"
        class="cursor-pointer button_secondary_default"
        @click="navigateTo(`users?user_id=${data.userId}`, { open: { target: '_blank' } })"
      >
        <span class="body_regular">Voir plus</span>
        <SvgIcon name="link" class="w-[14px] h-[14px]"></SvgIcon>
      </div>
    </div>
    <div class="session_user_info__grid">
      <section>
        <h5>E-mail</h5>
        <p class="truncate">{{ data.email ?? "-" }}</p>
      </section>
      <section>
        <h5>Matricule</h5>
        <p class="truncate">{{ data.matricule ?? "-" }}</p>
      </section>
      <section>
        <h5>Intitulé de poste</h5>
        <p class="truncate">{{ data.job ?? "-" }}</p>
      </section>
      <section>
        <h5>Manager</h5>
        <p class="truncate">{{ data.managerEmail ?? "-" }}</p>
      </section>
      <section>
        <h5>Équipe</h5>
        <p class="truncate">{{ data.team ?? "-" }}</p>
      </section>
      <section>
        <h5>Site</h5>
        <p class="truncate">{{ data.site ?? "-" }}</p>
      </section>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.session_user_info__container {
  @apply pt-[8px];
  border-bottom: 1px solid var(--grey-lightest);
}

.session_user_info__grid {
  @apply flex flex-col gap-[8px] px-[8px] mb-[32px] mt-[16px];

  section {
    @apply inline-flex px-[8px];

    h5 {
      @apply min-w-[112px] mr-[8px];
      color: var(--text-secondary-color);
    }
  }
}
</style>
